import { CELL_HEIGHT } from '@/shared/constants/gridConstants';

export const GRID_HEADING_CHAR_WIDTH = 6.666666895151138;
export const LABEL_PADDING_ROWS = 2;

/**
 * World-space width of the row-number gutter at the given zoom, matching
 * {@link GridHeadings} `calculateRowWidth` / `drawVerticalBar`.
 */
export function rowHeadingWorldWidth(scale: number, bottomRowDigitCount: number): number {
  if (scale <= 0) {
    return CELL_HEIGHT;
  }
  const rowWidth = (bottomRowDigitCount * GRID_HEADING_CHAR_WIDTH) / scale + (LABEL_PADDING_ROWS / scale) * 2;
  return Math.max(rowWidth, CELL_HEIGHT / scale);
}
